// Helpers for FlowResponseTimeDto ({avg, max, items: [{timestamp, avg, max}]})

// Charts plot the highest value of each bucket
export const toChartData = (statistic) =>
    (statistic?.items || []).map(item => ({
        dateCreated: item?.timestamp,
        duration: Number((Number(item?.max) || 0).toFixed(2)),
    }));

export const formatSeconds = (statistic) =>
    statistic ? `${(Number(statistic.avg) || 0).toFixed(2)}s` : "-";

export const hasActivity = (chartData) => chartData.some(d => d.duration > 0);
